import React from 'react'
import classNames from 'classnames'
import { v4 } from 'uuid'

const ToggleSwitch = (props) => {
  const { className, checked, onClick, ...attrs } = props
  const id = v4()

  return (
    <div className={classNames('toggle-switch', className)} {...attrs}>
      <input type='checkbox' id={id} className='cbx d-none' checked={checked} readOnly />
      <label htmlFor={id} className='toggle' onClick={onClick}>
        <span />
      </label>
    </div>
  )
}

export default ToggleSwitch
